// extracted by mini-css-extract-plugin
export default {"tab-list":"issues-page_tab-list__UPTyF","tab-list__panel":"issues-page_tab-list__panel__ObLgk"};